import { render, staticRenderFns } from "./DispatchResultDialog.vue?vue&type=template&id=27b2b302&scoped=true"
import script from "./DispatchResultDialog.vue?vue&type=script&lang=js"
export * from "./DispatchResultDialog.vue?vue&type=script&lang=js"
import style0 from "./DispatchResultDialog.vue?vue&type=style&index=0&id=27b2b302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b2b302",
  null
  
)

export default component.exports